// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Bdsq","header":"Messages_header__2iOHL"};